import { useQuery } from '@tanstack/react-query';
import { gql } from 'graphql-request';
import { gqlClient } from '@/lib';
import { createAccountDeletionPreviewQueryKey } from '@/utils/queryKeys';
import type { AccountDeletionPreviewQuery } from './useAccountDeletionPreview.generated';

const query = gql`
  query AccountDeletionPreview {
    accountDeletionPreview {
      canDelete
      blockers {
        kind
        id
        title
      }
      scheduleCount
      experienceCount
      sharedItems {
        kind
        id
        title
      }
      activeSubscriptions {
        plan
      }
      sharedSchedulesLosingFeeds
    }
  }
`;

export type AccountDeletionPreview =
  AccountDeletionPreviewQuery['accountDeletionPreview'];

const selector = (data: AccountDeletionPreviewQuery) =>
  data.accountDeletionPreview;

export const useAccountDeletionPreview = (enabled: boolean) => {
  return useQuery({
    queryKey: createAccountDeletionPreviewQueryKey(),
    queryFn: () => gqlClient.request<AccountDeletionPreviewQuery>(query),
    select: selector,
    enabled,
    // Sharing changes elsewhere decide whether deletion is allowed, so every
    // open of the dialog asks again.
    gcTime: 0,
    staleTime: 0,
  });
};
